import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'system',
    name: 'system',
    children: [
      {
        path: 'dict',
        name: 'system_dict',
        component: () => import('@/layout/routerView.vue'),
        redirect: '/system/dict/category',
        meta: { title: '字典管理', order: 40 },
        children: [
          {
            path: 'assets-cate',
            name: 'system_dict_assets_cate',
            component: () => import('@/views/FixedAsset/Category/index.vue'),
            meta: { title: '资产分类', order: 60 }
          },
          {
            path: 'assets-belong',
            name: 'system_dict_assets_belong',
            component: () => import('@/views/FixedAsset/Belong/index.vue'),
            meta: { title: '资产归属', order: 70 }
          }
        ]
      }
    ]
  },
  {
    path: 'resources',
    name: 'resources',
    children: [
      {
        path: 'assets',
        name: 'resources_assets',
        component: () => import('@/views/FixedAsset/List/index.vue'),
        meta: { title: '固定资产管理', order: 40 }
      }
    ]
  }
]

export default routes
